import ApiService from "./api.service";
export default class NotificationService extends ApiService {
    static async markAllNotificationsAsRead( axiosInstance) {
        const response = await axiosInstance.post(`${this.base_url}/read-all`);
        return response.data;
    }
    static base_url = `${super.base_url}/notifications`;
}
